import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const PARENT_FRAGMENT = gqlTagGira`
    fragment jiraBusinessParentFieldFragment on JiraParentIssueField {
        fieldId
        parentIssue {
            id @include(if: $withParentIssueId)
            issueId
            key
            rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
                aliasFieldId
                ... on JiraSingleLineTextField {
                    text
                }
            }
            fields: fieldsByIdOrAlias(idsOrAliases: ["summary", "issuetype", "issuecolor", "status"], ignoreMissingFields: true) @connection (key: "parentFields") @include(if: $isParentFieldVisible) {
                fieldId
                name
                aliasFieldId
                type
                ... on JiraColorField {
                    color {
                        colorKey
                    }
                }
                ... on JiraSingleLineTextField {
                    text
                }
                ... on JiraStatusField {
                    status {
                        name
                        statusCategory {
                            statusCategoryId
                        }
                    }
                }
                ... on JiraIssueTypeField {
                    issueType {
                        name
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
`;
